import Vue from 'vue'
/**
 * @author  José Luis R. <jose.ruiz@jbge.com>
 *
 * Rejectes sinister's files
 *
 */
const rejectFiles = payload =>
  Vue.$http.put('catalogs/common/reject/file/', payload)
    .then()
    .catch((err) => { throw err })

export default rejectFiles


// WEBPACK FOOTER //
// ./src/services/sinister/rejectFiles.js